import { useEffect } from "react"
import { useLocation, useHistory } from "react-router-dom";
import { get } from "src/component/fetch";
import {Image} from "antd"
import { useState } from "react";
 function CertificateView() {
  const [certificateImg,setCertificateImg] = useState('')
  const [imgVisible, setImgVisible] = useState(false)
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };
  const query = useQuery()
  const history = useHistory();
  const p = query.get('p') || ''
  const m = query.get('m') || ''
  const t = query.get('t') || ''
  const getCertificate = () => {
    get(`/shop/api/project/certificate/preview?p=${p}&m=${m}&t=${t}`,{},false).then(res=>{
      if(res.code === 0){
        setCertificateImg(res.data.image)
      }
    })
  }
  useEffect(()=>{
    getCertificate()
  },[])
  return (
    <div className="certificateView">
      <Image.PreviewGroup
            width={200}
            style={{ display: 'none' }}
            src={certificateImg}
            preview={{
              visible: true,
              src: certificateImg,
              closeIcon:null
            }}
          />
    </div>
  )
}
export default CertificateView